declare namespace $ {

	type $shm_knowledge_manual__menu_title_shm_knowledge_1 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_knowledge_manual['menu_title'] >
	>
	type $shm_knowledge_manual__kind_shm_knowledge_2 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_knowledge_manual['kind'] >
	>
	type $shm_knowledge_manual__api_url_shm_knowledge_3 = $mol_type_enforce<
		ReturnType< $shm_knowledge['knowledge_api_url'] >
		,
		ReturnType< $shm_knowledge_manual['api_url'] >
	>
	type $shm_knowledge_manual__api_headers_shm_knowledge_4 = $mol_type_enforce<
		ReturnType< $shm_knowledge['knowledge_api_headers'] >
		,
		ReturnType< $shm_knowledge_manual['api_headers'] >
	>
	type $shm_knowledge_manual__menu_title_shm_knowledge_5 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_knowledge_manual['menu_title'] >
	>
	type $shm_knowledge_manual__kind_shm_knowledge_6 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_knowledge_manual['kind'] >
	>
	type $shm_knowledge_manual__api_url_shm_knowledge_7 = $mol_type_enforce<
		ReturnType< $shm_knowledge['knowledge_api_url'] >
		,
		ReturnType< $shm_knowledge_manual['api_url'] >
	>
	type $shm_knowledge_manual__api_headers_shm_knowledge_8 = $mol_type_enforce<
		ReturnType< $shm_knowledge['knowledge_api_headers'] >
		,
		ReturnType< $shm_knowledge_manual['api_headers'] >
	>
	type $shm_hitalama_guide_toggle__section_shm_knowledge_9 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_guide_toggle['section'] >
	>
	export class $shm_knowledge extends $mol_book2_catalog {
		Guide( ): $shm_hitalama_guide
		Documentation( ): $shm_knowledge_manual
		Instructions( ): $shm_knowledge_manual
		Showcase( ): $shm_showcase
		title( ): string
		menu_title( ): string
		param( ): string
		knowledge_api_url( ): string
		knowledge_api_headers( ): Record<string, any>
		Help( ): $shm_hitalama_guide_toggle
		spreads( ): ({ 
			'guide': ReturnType< $shm_knowledge['Guide'] >,
			'documentation': ReturnType< $shm_knowledge['Documentation'] >,
			'instructions': ReturnType< $shm_knowledge['Instructions'] >,
			'showcase': ReturnType< $shm_knowledge['Showcase'] >,
		}) 
		Spread_default( ): ReturnType< $shm_knowledge['Guide'] >
	}
	
}

//# sourceMappingURL=knowledge.view.tree.d.ts.map